/* eslint-disable no-unused-vars */
import { envConfig } from '@hc/config';
import { log } from '@hc/logger';
import { queryClient } from '@hc/utils';
import { httpRequest } from '@hc/utils/axios';
import { toast } from 'react-hot-toast';
import create from 'zustand';

export const useMasterTime = create((set, get) => ({
  masterTimeData: [],
  loading: null,
  error: null,
  getMasterTimeData: async () => {
    try {
      set({ loading: true });
      // For preventing duplicate request, we're using react-query

      const { data, status } = await queryClient.fetchQuery({
        queryKey: ['masterTime'],
        queryFn: async () => {
          const { data } = await httpRequest(
            'get',
            `${envConfig.api_url}/master/get-time`,
            {},
            true
          );
          return data;
        },
        staleTime: Infinity,
      });

      const masterTimeDataCopy = [];

      if (Array.isArray(data) && data?.length > 0) {
        data.map((val) => {
          masterTimeDataCopy.push({
            value: val?.id ?? '',
            name: val?.time ?? '',
            label: val?.time ?? '',
          });
        });
      }
      return set((state) => ({
        loading: false,
        masterTimeData: masterTimeDataCopy,
      }));
    } catch (error) {
      set({ loading: false });
      log('error', error);
      return toast.error(
        error?.status?.message ??
          error?.message ??
          'Something went wrong please try again!'
      );
    }
  },
}));
